import { create } from 'zustand';
import type { Node, ColorPickerTarget } from '../types';

interface UIState {
  modalNode: Node | null;
  editNode: Node | null;
  editTitle: string;
  editSummary: string;
  editDescription: string;
  colorPickerNode: ColorPickerTarget | null;
  selectedColor: string;
  showMermaidModal: boolean;
  mermaidCode: string;
  copiedToClipboard: boolean;
  sidebarVisible: boolean;

  setModalNode: (node: Node | null) => void;
  setEditNode: (node: Node | null) => void;
  setEditTitle: (title: string) => void;
  setEditSummary: (summary: string) => void;
  setEditDescription: (desc: string) => void;
  setColorPickerNode: (target: ColorPickerTarget | null) => void;
  setSelectedColor: (color: string) => void;
  setShowMermaidModal: (show: boolean) => void;
  setMermaidCode: (code: string) => void;
  setCopiedToClipboard: (copied: boolean) => void;
  setSidebarVisible: (visible: boolean) => void;
}

export const useUIStore = create<UIState>()((set) => ({
  modalNode: null,
  editNode: null,
  editTitle: '',
  editSummary: '',
  editDescription: '',
  colorPickerNode: null,
  selectedColor: '#f87171',
  showMermaidModal: false,
  mermaidCode: '',
  copiedToClipboard: false,
  sidebarVisible: true,

  setModalNode: (modalNode) => set({ modalNode }),
  setEditNode: (editNode) => set({ editNode }),
  setEditTitle: (editTitle) => set({ editTitle }),
  setEditSummary: (editSummary) => set({ editSummary }),
  setEditDescription: (editDescription) => set({ editDescription }),
  setColorPickerNode: (colorPickerNode) => set({ colorPickerNode }),
  setSelectedColor: (selectedColor) => set({ selectedColor }),
  setShowMermaidModal: (showMermaidModal) => set({ showMermaidModal }),
  setMermaidCode: (mermaidCode) => set({ mermaidCode }),
  setCopiedToClipboard: (copiedToClipboard) => set({ copiedToClipboard }),
  setSidebarVisible: (sidebarVisible) => set({ sidebarVisible }),
}));
